import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

const WA = "https://wa.me/393520716656?text=Ciao%20SS%20Europa%2C%20ho%20dimenticato%20la%20mia%20password.%20La%20mia%20matricola%20%C3%A8%3A%20";

export default function ForgotPassword() {
  return (
    <div className="page-bg min-h-[70vh] flex items-center justify-center px-4 py-14">
      <div className="card-elevated p-8 max-w-md w-full fade-up">
        <div className="flex justify-center mb-4"><BrandLogo size="lg" withText={false} /></div>
        <h1 className="font-display font-extrabold text-2xl text-[#0B3D91] text-center" data-testid="fp-title">Password dimenticata?</h1>
        <p className="mt-3 text-sm text-[#5A6A94] text-center">
          Per motivi di sicurezza <strong>solo l'amministrazione</strong> può reimpostare la password associata a una matricola.
          Scrivici su WhatsApp indicando la tua <strong>matricola (6 cifre)</strong>: ti forniremo una nuova password temporanea.
        </p>

        <a
          href={WA}
          target="_blank" rel="noopener noreferrer"
          className="mt-6 w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-white font-semibold shadow-sm hover:shadow-md transition-all bg-[#25D366] hover:bg-[#1FBB58]"
          data-testid="fp-whatsapp-btn"
        >
          <MessageCircle size={16} /> Scrivici su WhatsApp
        </a>

        <p className="mt-6 text-sm text-center text-[#5A6A94]">
          <Link to="/login" className="text-[#0B3D91] font-semibold">← Torna al login</Link>
        </p>
      </div>
    </div>
  );
}
